import React from "react";
import "./Gallery.css";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { GalleryImages as images } from "./GalleryImages";
import Slider from "react-slick";

import "react-lazy-load-image-component/src/effects/blur.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export const Gallery = () => {
  // const [loading, setLoading] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    dotsClass: "slick-dots",
  };

  // if (loading) {
  //   return <div className="carousel__loading">Loading...</div>;
  // }

  if (!images.length) {
    return <div className="carousel__error">No images available</div>;
  }

  return (
    <div className="gallery">
      <div className="carousel">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} className="carousel__image-container">
              <LazyLoadImage
                effect="blur"
                src={image.url}
                alt={`Slide ${index}`}
                className="carousel__image"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
